import * as angular from 'angular';

export class AnchorSmoothScrollService {
    scrollDown(startY: number, stopY: number, speed: number, distance: number) {
        var timer = 0;

        var step = Math.round(distance / 10);
        var leapY = startY + step;

        for (var i = startY; i < stopY; i += step) {
            setTimeout('window.scrollTo(0, ' + leapY + ')', timer * speed);
            leapY += step;
            if (leapY > stopY) {
                leapY = stopY;
            }
            timer++;
        }
    }

    scrollUp(startY: number, stopY: number, speed: number, distance: number) {
        var timer = 0;

        var step = Math.round(distance / 10);
        var leapY = startY - step;

        for (var i = startY; i > stopY; i -= step) {
            setTimeout('window.scrollTo(0, ' + leapY + ')', timer * speed);
            leapY -= step;
            if (leapY < stopY) {
                leapY = stopY;
            }
            timer++;
        }
    }

    scrollToTop(stopY: number) {
        this.scrollTo(null, stopY);
    }

    scrollTo(elementId: string, speed: number) {
        // This scrolling function
        // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript

        var element = document.getElementById(elementId);

        if (element) {
            var startY = this.getCurrentPagePosition(window, document);
            var stopY = this.getElementY(document, element);

            var distance = stopY > startY ? stopY - startY : startY - stopY;

            if (distance < 100) {
                this.scrollToTop(stopY);
            } else {
                var defaultSpeed = Math.round(distance / 100);
                speed = speed || (defaultSpeed > 20 ? 20 : defaultSpeed);

                if (stopY > startY) {
                    this.scrollDown(startY, stopY, speed, distance);
                } else {
                    this.scrollUp(startY, stopY, speed, distance);
                }
            }
        }
    }

    scrollToInner(rootID: string, elementID: string, time: number) {
        var root = $(document.getElementById(rootID));
        var element = $(document.getElementById(elementID));
        var topWrapper = root.offset().top;
        var topElement = element.offset().top;
        root.parent().animate({ scrollTop: topElement - topWrapper }, time);
    }

    private getCurrentPagePosition(window: Window, document: Document) {
        // Firefox, Chrome, Opera, Safari
        if (window.pageYOffset) {
            return window.pageYOffset;
        }
        // Internet Explorer 6 - standards mode
        if (document.documentElement && document.documentElement.scrollTop) {
            return document.documentElement.scrollTop;
        }
        // Internet Explorer 6, 7 and 8
        if (document.body.scrollTop) {
            return document.body.scrollTop;
        }
        return 0;
    }

    private getElementY(document: Document, element: HTMLElement) {
        var y = element.offsetTop;
        var node = element;
        while (node.offsetParent && node.offsetParent !== document.body) {
            node = <HTMLElement>node.offsetParent;
            y += node.offsetTop;
        }
        return y;
    }
}

angular.module('app.common').service('anchorSmoothScroll', AnchorSmoothScrollService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/anchorSmoothScroll.service.ts